import { SxProps } from "@mui/material"

export const sxTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "24px",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left"
}

export const sxSubtitle: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 400,
  maxWidth: '650px',
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "justify",
  color: '#4C4C4C'
}

export const sxTypographyAdvice: SxProps = {
  color: '#5F5F5F',
  fontFamily: 'Unimed-Sans',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '150%',
}

export const sxTypographyAdviceTitle: SxProps = {
  color: '#383838',
  fontFamily: 'UnimedSans-Bold',
  fontSize: '16px',
  fontStyle: 'normal',
  lineHeight: '150%',
}

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxInput: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  maxWidth: '250px',
  minWidth: '230px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset',
    minWidth: 'unset'
  },
  '@media (min-width: 768px) and (max-width: 899px)': {
    minWidth: '400px'
  }
}

export const sxLabeledOutlinedInput: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  '@media (max-width: 768px)': {
    width: '100%'
  }
}

export const sxButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px'
}

export const sxFindCoverageByTussBox: SxProps = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '15px',
  alignItems: 'flex-end',
  width: '100%'
}

export const sxCircularLoadingProgressCoverage: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '750px',
  height: '100%',
  alignItems: 'center',
  marginTop: '100px'
}

export const sxError: SxProps = {
  color: '#D84141',
  fontSize: '12px'
}